import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isCorporates, setIsCorporates] = useState(false);
  const [isStorages, setIsStorages] = useState(false);
  const [isProfiles, setIsProfiles] = useState(false);
  const [isUsers, setIsUsers] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isTasks, setIsTasks] = useState(false);
  const [isTemplateTask, setIsTemplateTask] = useState(false);
  const [isMessage, setIsMessage] = useState(false);
  const [isContent, setIsContent] = useState(false);
  const [isBAST, setIsBAST] = useState(false);

  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");

  const [isReport, setIsReport] = useState(false);
  const [isReportProductInventory, setIsReportProductInventory] = useState(false);
  const [isReportSales, setIsReportSales] = useState(false);
  const [isReportPurchase, setIsReportPurchase] = useState(false);
  const [isReportTransaction, setIsReportTransaction] = useState(false);

  const [isHumanResources, setIsHumanResources] = useState(false);
  const [isOrganizations, setIsOrganizations] = useState(false);
  const [isEmployees, setIsEmployees] = useState(false);
  const [isPayrolls, setIsPayrolls] = useState(false);
  const [isPayrollSchedules, setIsPayrollSchedule] = useState(false);
  const [isKeyPerformance, setIsKeyPerformance] = useState(false);
  const [isKeyPerformanceSub, setIsKeyPerformanceSub] = useState(false);
  const [isHRFinance, setIsHRFinance] = useState(false);
  const [isCalendar, setIsCalendar] = useState(false);

  const [isEngineering, setIsEngineering] = useState(false);
  const [isBudgetCategory, setIsBudgetCategory] = useState(false);

  const [isAssets, setIsAssets] = useState(false);
  const [isAssetCategories, setIsAssetCategories] = useState(false);
  const [isVendors, setIsVendors] = useState(false);

  const [isProducts, setIsProducts] = useState(false);
  const [isProductCategories, setIsProductCategories] = useState(false);

  const [isInventories, setIsInventories] = useState(false);
  const [isLand, setIsLand] = useState(false);
  const [isSurvey, setIsSurvey] = useState(false);
  const [isCustomer, setIsCustomer] = useState(false);
  const [isMarketing, setIsMarketing] = useState(false);

  const [isSales, setIsSales] = useState(false);
  const [isCampaigns, setIsCampaigns] = useState(false);
  const [isSalesOption, setIsSalesOption] = useState(false);
  const [isLandOption, setIsLandOption] = useState(false);
  const [isBASTOption, setIsBASTOption] = useState(false);
  const [isLegal, setIsLegal] = useState(false);
  const [isPermission, setIsPermission] = useState(false);

  const [isProcurements, setIsProcurements] = useState(false);
  const [isAccounting, setIsAccounting] = useState(false);
  const [isAccountingAccount, setIsAccountingAccount] = useState(false);
  const [isCurrentState, setIsCurrentState] = useState("Dashboard");
  const [isBudget, setIsBudget] = useState(false);
  const [isFinanceReport, setIsFinanceReport] = useState(false);

  const [isNotif, setIsNotif] = useState(false);

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id)) document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    if (!userRole) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj.data && obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role) setRoles(obj?.data?.user?.user_position?.position_role.method);
      else setRoles(null);

      if (obj?.data) setUserType(obj?.data?.userType);
    }

    document.body.classList.remove("twocolumn-panel");
    if (isCurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (isCurrentState !== "Report") {
      setIsReport(false);
    }
    if (isCurrentState !== "HumanResources") {
      setIsHumanResources(false);
    }
    if (isCurrentState !== "Engineering") {
      setIsEngineering(false);
    }
    if (isCurrentState !== "Corporates") {
      setIsCorporates(false);
    }
    if (isCurrentState !== "Storage") {
      setIsStorages(false);
    }
    if (isCurrentState !== "Tasks") {
      setIsTasks(false);
    }
    if (isCurrentState !== "Messages") {
      setIsMessage(false);
    }
    if (isCurrentState !== "Calendar") {
      setIsCalendar(false);
    }
    if (isCurrentState !== "Products") {
      setIsProducts(false);
    }
    if (isCurrentState !== "Assets") {
      setIsAssets(false);
    }
    if (isCurrentState !== "Land") {
      setIsLand(false);
    }
    if (isCurrentState !== "Legal") {
      setIsLegal(false);
    }
    if (isCurrentState !== "Permission") {
      setIsPermission(false);
    }
    if (isCurrentState !== "Inventories") {
      setIsInventories(false);
    }
    if (isCurrentState !== "Sales") {
      setIsSales(false);
    }
    if (isCurrentState !== "Procurements") {
      setIsProcurements(false);
    }
    if (isCurrentState !== "Accounting") {
      setIsAccounting(false);
    }
    if (isCurrentState !== "Profiles") {
      setIsProfiles(false);
    }
    if (isCurrentState !== "Users") {
      setIsUsers(false);
    }
    if (isCurrentState !== "Admin") {
      setIsAdmin(false);
    }
    if (isCurrentState !== "Content") {
      setIsContent(false);
    }
    if (isCurrentState !== "BAST") {
      setIsBAST(false);
    }
    if (isCurrentState !== "Budget") {
      setIsBudget(false);
    }
    if (isCurrentState !== "Notif") {
      setIsNotif(false);
    }
  }, [history, isNotif, isBAST, isUsers, isAdmin, isLand, isLegal, isPermission, isBudget, isUsers, isProfiles, isCurrentState, isTemplateTask, isDashboard, isReport, isStorages, isHumanResources, isEngineering, isCorporates, isTasks, isCalendar, isMessage, isAssets, isProducts, isSales, isProcurements, isAccounting, isContent, userRole]);

  const menuItems = [{
      id: "Dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIsCurrentState("Dashboard");
        updateIconSidebar(e);
      },
      stateVariables: isDashboard,
      subItems: [
        {
          id: "menuDashboardGeneral",
          label: "General",
          link: "/dashboard-general",
          parentId: "Dashboard",
        },
        {
          id: "menuDashboardEnginering",
          label: "Teknik - Pembangunan",
          link: "/dashboard-enginering-progress",
          parentId: "Dashboard",
          visible: userType === "admin" || userType === "client" ? "" : userRole && userRole.split(",").indexOf("viewDashboard") !== -1 ? "" : " d-none",
        },
        {
          id: "menuDashboardEngineringOpname",
          label: "Teknik - SPK",
          link: "/dashboard-enginering-opname",
          parentId: "Dashboard",
          visible: userType === "admin" || userType === "client" ? "" : userRole && userRole.split(",").indexOf("viewDashboard") !== -1 ? "" : " d-none",
        },
        {
          id: "menuDashboardEngineringOpname",
          label: "Teknik - Material",
          link: "/dashboard-enginering-material",
          parentId: "Dashboard",
          visible: userType === "admin" || userType === "client" ? "" : userRole && userRole.split(",").indexOf("viewDashboard") !== -1 ? "" : " d-none",
        },
      ],
    },
    // {
    //   id: "Dashboard",
    //   label: "Dashboard",
    //   icon: "ri-dashboard-2-line",
    //   link: "/dashboard",
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsCurrentState("Widgets");
    //   },
    //   stateVariables: isDashboard,
    // visible:
    // userType === "admin" || userType === "client" || userType === "company"
    //   ? ""
    //   : userRole && userRole.split(",").indexOf("viewDashboard") !== -1
    //     ? ""
    //     : " d-none",
    // },
    {
      id: "Tasks",
      label: "Task",
      icon: "ri-task-line",
      link: "/#",
      stateVariables: isTasks,
      click: function (e) {
        e.preventDefault();
        setIsTasks(!isTasks);
        setIsCurrentState("Tasks");
        updateIconSidebar(e);
      },
      visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewTaskList") !== -1 || userRole.split(",").indexOf("viewTaskListDetail") !== -1 || userRole.split(",").indexOf("viewTicket") !== -1 || userRole.split(",").indexOf("viewTask") !== -1 || userRole.split(",").indexOf("viewTaskDetail") !== -1) ? "" : " d-none",
      subItems: [
        {
          id: "menuTemplateTask",
          label: "Task Template",
          link: "/#",
          parentId: "Tasks",
          isChildItem: true,
          stateVariables: isTemplateTask,
          click: function (e) {
            e.preventDefault();
            setIsTemplateTask(!isTemplateTask);
          },
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewTaskList") !== -1 ? "" : " d-none",
          childItems: [
            {
              id: 1,
              label: "Task Template",
              link: "/task-list",
              parentId: "Tasks",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewTaskList") !== -1 ? "" : " d-none",
            },
            // {
            //   id: 2,
            //   label: "Print Template",
            //   link: "/print-template",
            //   parentId: "Tasks",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewTaskList") !== -1 ? "" : " d-none",
            // },
            {
              id: 3,
              label: "Task Category",
              link: "/task-category",
              parentId: "Tasks",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewTaskList") !== -1 ? "" : " d-none",
            },
            {
              id: 4,
              label: "Ticket Category",
              link: "/ticket-category",
              parentId: "Tasks",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewTaskList") !== -1 ? "" : " d-none",
            },
          ],
        },
        // {
        //   id: "menuTaskList",
        //   label: "Repetitive Tasks",
        //   link: "/task-list",
        //   parentId: "Tasks",
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewTaskList") !== -1 || userRole.split(",").indexOf("viewTaskListDetail") !== -1) ? "" : " d-none",
        // },
        // {
        //   id: "menuTicket",
        //   label: "Tickets",
        //   link: "/ticket",
        //   parentId: "Tasks",
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewTicket") !== -1 ? "" : " d-none",
        // },
        {
          id: "menuTicket",
          label: "Pesanan Pekerjaan",
          link: "/ticket",
          parentId: "Report",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewTicket") !== -1 ? "" : " d-none",
        },
        {
          id: "menuTask",
          label: "Penugasan",
          link: "/task",
          parentId: "Tasks",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewTask") !== -1 || userRole.split(",").indexOf("viewTaskDetail") !== -1) ? "" : " d-none",
        },
      ],
    },
    {
      id: "Report",
      label: "Reporting",
      icon: "ri-file-chart-line",
      link: "/#",
      stateVariables: isReport,
      click: function (e) {
        e.preventDefault();
        setIsReport(!isReport);
        setIsCurrentState("Report");
        updateIconSidebar(e);
      },
      visible:
        userType === "admin" || userType === "client" || userType === "company"
          ? ""
          : userRole && (userRole.split(",").indexOf("viewHumanResourcesReport") !== -1 || userRole.split(",").indexOf("viewAssetReport") !== -1 || userRole.split(",").indexOf("viewLegalityReport") !== -1 || userRole.split(",").indexOf("viewTeknikReport") !== -1 || userRole.split(",").indexOf("viewSalesReport") !== -1 || userRole.split(",").indexOf("viewPurchaseReport") !== -1 || userRole.split(",").indexOf("viewFinancialReport") !== -1)
            ? ""
            : " d-none",
      subItems: [
        {
          id: "menuReportProductInventory",
          label: "Persediaan",
          link: "/#",
          parentId: "Report",
          isChildItem: true,
          stateVariables: isReportProductInventory,
          click: function (e) {
            e.preventDefault();
            setIsReportProductInventory(!isReportProductInventory);
          },
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewTeknikReport") !== -1 ? "" : " d-none",
          childItems: [
            {
              id: 1,
              label: "Stok Persediaan",
              link: "/report-product-stock",
              parentId: "Report",
            },
            {
              id: 2,
              label: "Penerimaan Barang",
              link: "/report-product-inbound",
              parentId: "Report",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewStockCard") !== -1 ? "" : " d-none",
            },
            {
              id: 3,
              label: "Pengeluaran Barang",
              link: "/report-product-outbound",
              parentId: "Report",
            },
          ],
        },
        {
          id: "menuReportSales",
          label: "Sales",
          link: "/#",
          parentId: "Report",
          isChildItem: true,
          stateVariables: isReportSales,
          click: function (e) {
            e.preventDefault();
            setIsReportSales(!isReportSales);
          },
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReport") !== -1 ? "" : " d-none",
          childItems: [
            {
              id: 1,
              label: "Laporan Harian",
              link: "/report-sales-daily",
              parentId: "Report",
            },
            {
              id: 2,
              label: "Laporan Berkas Bank",
              link: "/report-sales-bank",
              parentId: "Report",
            },
            {
              id: 3,
              label: "Laporan Unit Terjual",
              link: "/report-sales-unit",
              parentId: "Report",
            },
            // {
            //   id: 3,
            //   label: "Sales Daily Report",
            //   link: "/report-sales-daily",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesDailyReport") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 4,
            //   label: "Sales By Product",
            //   link: "/report-sales-product",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReportByProduct") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 5,
            //   label: "Sales By Customer",
            //   link: "/report-sales-vendor",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReportByCustomer") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 6,
            //   label: "Sales By Category",
            //   link: "/report-sales-category",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReportByCategory") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 7,
            //   label: "Sales By Branch",
            //   link: "/report-sales-branch",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReportByBranch") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 8,
            //   label: "Sales By Company",
            //   link: "/report-sales-company",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReportByCompany") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 9,
            //   label: "Sales By Payment Type",
            //   link: "/report-sales-payment-type",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReportByPaymentType") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 10,
            //   label: "Sales Return",
            //   link: "/report-sales-return",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReturnReport") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 11,
            //   label: "Sales Refund",
            //   link: "/report-sales-refund",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesRefundReport") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 12,
            //   label: "Sales Tax",
            //   link: "/report-sales-tax",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesTaxReport") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 13,
            //   label: "Sales Closing Report",
            //   link: "/report-sales-closing",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesClosingReport") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 14,
            //   label: "Customer",
            //   link: "/report-sales-customer",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCustomerReport") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 15,
            //   label: "Customer Point",
            //   link: "/report-sales-customer-point",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCustomerPoinReport") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 16,
            //   label: "Coupon",
            //   link: "/report-sales-coupon",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCouponReport") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 17,
            //   label: "Compliment",
            //   link: "/report-sales-compliment",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewComplimentReport") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 18,
            //   label: "Promotion",
            //   link: "/report-sales-promotion",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPromotionReport") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 19,
            //   label: "CRM",
            //   link: "/report-sales-crm",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCRMReport") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 20,
            //   label: "Target & Realization",
            //   link: "/report-sales-target",
            //   parentId: "Report",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewTargetRealizationReport") !== -1 ? "" : " d-none",
            // },
          ],
        },
        {
          id: "menuReportPurchase",
          label: "Purchase",
          link: "/#",
          parentId: "Report",
          isChildItem: true,
          stateVariables: isReportPurchase,
          click: function (e) {
            e.preventDefault();
            setIsReportPurchase(!isReportPurchase);
          },
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchaseReport") !== -1 ? "" : " d-none",
          childItems: [
            {
              id: 1,
              label: "Laporan Pembelian Material",
              link: "/report-purchase-material",
              parentId: "Report",
            },
            {
              id: 2,
              label: "Laporan Pembelian",
              link: "/report-purchase-general",
              parentId: "Report",
            },
          ],
        },
        {
          id: "menuReportFinance",
          label: "Keuangan",
          link: "/#",
          parentId: "Report",
          isChildItem: true,
          stateVariables: isReportTransaction,
          click: function (e) {
            e.preventDefault();
            setIsReportTransaction(!isReportTransaction);
          },
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewFinancialReport") !== -1 ? "" : " d-none",
          childItems: [
            {
              id: 1,
              label: "Transaksi",
              link: "/report-transaction",
              parentId: "Report",
            },
            {
              id: 1,
              label: "Saldo Akun Keuangan",
              link: "/report-account-balance",
              parentId: "Report",
            },
          ],
        },
        // {
        //   id: "menuReportAsset",
        //   label: "Asset",
        //   link: "/#",
        //   parentId: "Report",
        //   isChildItem: true,
        //   stateVariables: isReportAssetInventory,
        //   click: function (e) {
        //     e.preventDefault();
        //     setIsReportAssetInventory(!isReportAssetInventory);
        //   },
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewAssetStockReport") !== -1 || userRole.split(",").indexOf("viewAssetStockCard") !== -1 || userRole.split(",").indexOf("viewAssetStockReportByBranch") !== -1 || userRole.split(",").indexOf("viewAssetStockReportByCompany") !== -1 || userRole.split(",").indexOf("viewAssetStockFoundandLossReport") !== -1 || userRole.split(",").indexOf("viewAssetStockDistributionReport") !== -1) ? "" : " d-none",
        //   childItems: [
        //     {
        //       id: 1,
        //       label: "Asset Stock Report",
        //       link: "/report-asset-stock",
        //       parentId: "Report",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetStockReport") !== -1 ? "" : " d-none",
        //     },
        //     {
        //       id: 2,
        //       label: "Asset Stock Card",
        //       link: "/report-asset-stock-card",
        //       parentId: "Report",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetStockCard") !== -1 ? "" : " d-none",
        //     },
        //     {
        //       id: 3,
        //       label: "Asset Stock By Branch",
        //       link: "/report-asset-stock-branch",
        //       parentId: "Report",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetStockReportByBranch") !== -1 ? "" : " d-none",
        //     },
        //     {
        //       id: 4,
        //       label: "Asset Stock By Company",
        //       link: "/report-asset-company",
        //       parentId: "Report",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetStockReportByCompany") !== -1 ? "" : " d-none",
        //     },
        //     {
        //       id: 5,
        //       label: "Asset Stock Found and Loss",
        //       link: "/report-asset-stock-found-loss",
        //       parentId: "Report",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetStockFoundandLossReport") !== -1 ? "" : " d-none",
        //     },
        //     {
        //       id: 6,
        //       label: " Asset Stock Distribution",
        //       link: "/report-asset-stock-distribution",
        //       parentId: "Report",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPayrollReport") !== -1 ? "" : " d-none",
        //     },
        //   ],
        // },
      ],
    },
    {
      id: "Calendar",
      label: "Kalender",
      icon: "ri-calendar-event-line",
      link: "/calendar",
      click: function (e) {
        e.preventDefault();
        setIsCurrentState("Calendar");
      },
      stateVariables: isCalendar,
      visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPermission") !== -1 ? "" : " d-none",
    },
    // {
    //   id: "Corporates",
    //   label: "Corporates",
    //   icon: "ri-building-line",
    //   link: "/#",
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsCorporates(!isCorporates);
    //     setIsCurrentState("Corporates");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: isCorporates,
    //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (
    //     userRole.split(",").indexOf("viewClient") !== -1 ||
    //     userRole.split(",").indexOf("viewCompany") !== -1 ||
    //     userRole.split(",").indexOf("viewBrand") !== -1 ||
    //     userRole.split(",").indexOf("viewBranch") !== -1) ? "" : " d-none",
    //   subItems: [
    //     {
    //       id: "menuClient",
    //       label: "Clients",
    //       link: "/client",
    //       parentId: "Corporates",
    //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewClient") !== -1 ? "" : " d-none",
    //     },
    //     {
    //       id: "menuCompany",
    //       label: "Companies",
    //       link: "/company",
    //       parentId: "Corporates",
    //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCompany") !== -1 ? "" : " d-none",
    //     },

    //     {
    //       id: "menuBranch",
    //       label: "Branches",
    //       link: "/branch",
    //       parentId: "Corporates",
    //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewBranch") !== -1 ? "" : " d-none",
    //     },
    //     {
    //       id: "menuUnit",
    //       label: "Units",
    //       link: "/unit",
    //       parentId: "Corporates",
    //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewBrand") !== -1 ? "" : " d-none",
    //     },
    //     {
    //         id: "menuCorporatesData",
    //         label: "Corporates Data",
    //         link: "/#",
    //         parentId: "Corporates",
    //         isChildItem: true,
    //         click: function (e) {
    //             e.preventDefault();
    //             setIsCorporatesSub(!isCorporatesSub);
    //         },
    //         stateVariables: isCorporatesSub,
    //         childItems: [
    //             { id: 1, label: "Addresses", link: "/address", parentId: "Corporates" },
    //             { id: 2, label: "Identities", link: "/address", parentId: "Corporates" },
    //             { id: 3, label: "Banks", link: "/address", parentId: "Corporates" },
    //             {
    //                 id: 4,
    //                 label: "Refferal Data",
    //                 link: "/#",
    //                 parentId: "Corporates",
    //                 isChildItem: true,
    //                 stateVariables: isReferralData,
    //                 click: function (e) {
    //                     e.preventDefault();
    //                     setIsReferralData(!isReferralData);
    //                 },
    //                 childItems: [
    //                     { id: 1, label: "Provinces", link: "/province", parentId: "Corporates" },
    //                     { id: 2, label: "Cities", link: "/city", parentId: "Corporates" },
    //                     { id: 3, label: "District", link: "/district", parentId: "Corporates" },
    //                     { id: 4, label: "Villages", link: "/village", parentId: "Corporates" },
    //                     { id: 6, label: "Bank Lists", link: "/bank", parentId: "Corporates" },
    //                 ],
    //             },
    //         ]
    //     }
    //   ],
    // },
    {
      id: "HumanResources",
      label: "Human Resource",
      icon: "ri-group-line",
      link: "/#",
      stateVariables: isHumanResources,
      click: function (e) {
        e.preventDefault();
        setIsHumanResources(!isHumanResources);
        setIsCurrentState("HumanResources");
        updateIconSidebar(e);
      },
      visible:
        userType === "admin" || userType === "client" || userType === "company"
          ? ""
          : userRole &&
            // userRole.split(",").indexOf("viewCompany") !== -1 ||
            // userRole.split(",").indexOf("viewBranch") !== -1 ||
            // userRole.split(",").indexOf("viewDepartment") !== -1 ||
            // userRole.split(",").indexOf("viewPosition") !== -1 ||
            (userRole.split(",").indexOf("viewEmployee") !== -1 ||
              userRole.split(",").indexOf("viewEmployeeContract") !== -1 ||
              userRole.split(",").indexOf("viewEmployeeContractTypes") !== -1 ||
              userRole.split(",").indexOf("viewPayrate") !== -1 ||
              userRole.split(",").indexOf("viewEmployeeLocation") !== -1 ||
              userRole.split(",").indexOf("viewPositionChange") !== -1 ||
              userRole.split(",").indexOf("viewEmployeeWarning") !== -1 ||
              userRole.split(",").indexOf("viewTermination") !== -1 ||
              userRole.split(",").indexOf("viewAttendanceSchedule") !== -1 ||
              userRole.split(",").indexOf("viewAttendanceScheduleDetail") !== -1 ||
              userRole.split(",").indexOf("viewAttendanceEvent") !== -1 ||
              userRole.split(",").indexOf("viewAttendance") !== -1 ||
              userRole.split(",").indexOf("viewAttendanceCheck") !== -1 ||
              userRole.split(",").indexOf("viewEmployeeFace") !== -1 ||
              userRole.split(",").indexOf("viewPayrollComponent") !== -1 ||
              userRole.split(",").indexOf("viewWorkGroup") !== -1 ||
              // userRole.split(",").indexOf("viewLoanTerm") !== -1 ||
              // userRole.split(",").indexOf("viewLoan") !== -1 ||
              // userRole.split(",").indexOf("viewReimbursement") !== -1 ||
              // userRole.split(",").indexOf("viewReimbursementType") !== -1 ||
              userRole.split(",").indexOf("viewPerformance") !== -1 ||
              userRole.split(",").indexOf("viewPerformancePredicate") !== -1 ||
              userRole.split(",").indexOf("viewPerformanceScore") !== -1 ||
              userRole.split(",").indexOf("viewPerformanceAppraisal") !== -1 ||
              userRole.split(",").indexOf("viewPerformanceAppraisalDetail") !== -1 ||
              userRole.split(",").indexOf("viewEmployeeAssessment") !== -1)
            ? ""
            : " d-none",
      subItems: [
        {
          id: "menuOrganisasi",
          label: "Organization",
          link: "/#",
          parentId: "HumanResources",
          isChildItem: true,
          stateVariables: isOrganizations,
          click: function (e) {
            e.preventDefault();
            setIsOrganizations(!isOrganizations);
          },
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewDepartment") !== -1 || userRole.split(",").indexOf("viewPosition") !== -1 || userRole.split(",").indexOf("viewCompany") !== -1 || userRole.split(",").indexOf("viewBranch") !== -1) ? "" : " d-none",
          childItems: [
            {
              id: "menuCompany",
              label: "Perusahaan",
              link: "/company",
              parentId: "Corporates",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCompany") !== -1 ? "" : " d-none",
            },
            {
              id: "menuBranch",
              label: "Cabang",
              link: "/branch",
              parentId: "Corporates",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewBranch") !== -1 ? "" : " d-none",
            },
            {
              id: 1,
              label: "Department",
              link: "/department",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewDepartment") !== -1 ? "" : " d-none",
            },
            {
              id: 2,
              label: "Position",
              link: "/position",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPosition") !== -1 ? "" : " d-none",
            },
            {
              id: 3,
              label: "Structure",
              link: "/structure",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewDepartment") !== -1 ? "" : " d-none",
            },
          ],
        },
        {
          id: "menuEmployees",
          label: "Employee",
          link: "/#",
          parentId: "HumanResources",
          isChildItem: true,
          stateVariables: isEmployees,
          click: function (e) {
            e.preventDefault();
            setIsEmployees(!isEmployees);
          },
          visible:
            userType === "admin" || userType === "client" || userType === "company"
              ? ""
              : userRole &&
                (userRole.split(",").indexOf("viewEmployee") !== -1 || userRole.split(",").indexOf("viewEmployeeContract") !== -1 || userRole.split(",").indexOf("viewEmployeeContractTypes") !== -1 || userRole.split(",").indexOf("viewPayrate") !== -1 || userRole.split(",").indexOf("viewEmployeeLocation") !== -1 || userRole.split(",").indexOf("viewPositionChange") !== -1 || userRole.split(",").indexOf("viewEmployeeWarning") !== -1 || userRole.split(",").indexOf("viewTermination") !== -1)
                ? ""
                : " d-none",
          childItems: [
            {
              id: 1,
              label: "Recruitment",
              link: "/employee",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewEmployee") !== -1 ? "" : " d-none",
            },
            {
              id: 2,
              label: "Contract",
              link: "/employee-contract",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewEmployeeContract") !== -1 || userRole.split(",").indexOf("viewEmployeeContractTypes") !== -1) ? "" : " d-none",
            },
            {
              id: 3,
              label: "Pay Rate",
              link: "/pay-rate",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPayrate") !== -1 ? "" : " d-none",
            },
            {
              id: 4,
              label: "Work Location",
              link: "/employee-location",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewEmployeeLocation") !== -1 ? "" : " d-none",
            },
            {
              id: 5,
              label: "Change Position",
              link: "/position-change",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPositionChange") !== -1 ? "" : " d-none",
            },
            {
              id: 6,
              label: "Warning Letter",
              link: "/warning-letter",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewEmployeeWarning") !== -1 ? "" : " d-none",
            },
            {
              id: 7,
              label: "Termination",
              link: "/termination",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewTermination") !== -1 ? "" : " d-none",
            },
          ],
        },
        {
          id: "menuAttend",
          label: "Payroll",
          link: "/#",
          parentId: "HumanResources",
          isChildItem: true,
          stateVariables: isPayrolls,
          click: function (e) {
            e.preventDefault();
            setIsPayrolls(!isPayrolls);
          },
          visible:
            userType === "admin" || userType === "client" || userType === "company"
              ? ""
              : userRole &&
                (userRole.split(",").indexOf("viewAttendanceSchedule") !== -1 ||
                  userRole.split(",").indexOf("viewAttendanceScheduleDetail") !== -1 ||
                  userRole.split(",").indexOf("viewAttendanceEvent") !== -1 ||
                  userRole.split(",").indexOf("viewAttendance") !== -1 ||
                  userRole.split(",").indexOf("viewAttendanceCheck") !== -1 ||
                  userRole.split(",").indexOf("viewEmployeeFace") !== -1 ||
                  userRole.split(",").indexOf("viewPayrollComponent") !== -1 ||
                  userRole.split(",").indexOf("viewWorkGroup") !== -1)
                ? ""
                : " d-none",
          childItems: [
            {
              id: 1,
              label: "Payroll Option",
              link: "/#",
              parentId: "HumanResources",
              isChildItem: true,
              stateVariables: isPayrollSchedules,
              click: function (e) {
                e.preventDefault();
                setIsPayrollSchedule(!isPayrollSchedules);
              },
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewWorkLocation") !== -1 || userRole.split(",").indexOf("viewPayrollComponent") !== -1 || userRole.split(",").indexOf("viewAttendanceSchedule") !== -1 || userRole.split(",").indexOf("viewAttendanceScheduleDetail") !== -1 || userRole.split(",").indexOf("viewAttendanceEvent") !== -1) ? "" : " d-none",
              childItems: [
                {
                  id: 1,
                  label: "Schedule",
                  link: "/attendance-schedule",
                  parentId: "HumanResources",
                  visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewPayrollComponent") !== -1 || userRole.split(",").indexOf("viewAttendanceSchedule") !== -1 || userRole.split(",").indexOf("viewAttendanceScheduleDetail") !== -1) ? "" : " d-none",
                },
                {
                  id: 2,
                  label: "Short & Free Day",
                  link: "/attendance-event",
                  parentId: "HumanResources",
                  visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAttendanceEvent") !== -1 ? "" : " d-none",
                },
                {
                  id: "menuAttendanceLocation",
                  label: "Attendance Location",
                  link: "/attendance-location",
                  parentId: "HumanResources",
                  visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewWorkLocation") !== -1 ? "" : " d-none",
                },
                {
                  id: 4,
                  label: "Payroll Component",
                  link: "/payroll-component",
                  parentId: "HumanResources",
                  visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPayrollComponent") !== -1 ? "" : " d-none",
                },
              ],
            },
            {
              id: "menuAttendance",
              label: "Kehadiran",
              link: "/attendance",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAttendance") !== -1 ? "" : " d-none",
            },

            {
              id: "menuAttendanceSummary",
              label: "Rekap Kehadiran",
              link: "/attendance-summary",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAttendance") !== -1 ? "" : " d-none",
            },
            {
              id: "menuPermission",
              label: "Perizinan",
              link: "/permission",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAttendance") !== -1 ? "" : " d-none",
            },
            {
              id: "menuFaceRegistrations",
              label: "Face Registration",
              link: "/attendance-face",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewEmployeeFace") !== -1 ? "" : " d-none",
            },
            {
              id: 5,
              label: "Work Group",
              link: "/work-group",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewWorkGroup") !== -1 ? "" : " d-none",
            },
            {
              id: 6,
              label: "Calculate Salary",
              link: "/payroll-salary",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPayrollSalary") !== -1 ? "" : " d-none",
            },
          ],
        },
        {
          id: "menuHRFinance",
          label: "Finance",
          link: "/#",
          parentId: "HumanResources",
          isChildItem: true,
          stateVariables: isHRFinance,
          click: function (e) {
            e.preventDefault();
            setIsHRFinance(!isHRFinance);
          },
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewLoan") !== -1 || userRole.split(",").indexOf("viewReimbursement") !== -1) ? "" : " d-none",
          childItems: [
            {
              id: 1,
              label: "Klaim Reimbursement",
              link: "/reimbursement",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewReimbursement") !== -1 ? "" : " d-none",
            },
            {
              id: 2,
              label: "Pinjaman Karyawan",
              link: "/loan",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLoan") !== -1 ? "" : " d-none",
            },
          ],
        },
        {
          id: "menuKPI",
          label: "Penilaian Karyawan",
          link: "/#",
          parentId: "HumanResources",
          isChildItem: true,
          stateVariables: isKeyPerformance,
          click: function (e) {
            e.preventDefault();
            setIsKeyPerformance(!isKeyPerformance);
          },
          visible:
            userType === "admin" || userType === "client" || userType === "company"
              ? ""
              : userRole && (userRole.split(",").indexOf("viewPerformance") !== -1 || userRole.split(",").indexOf("viewPerformancePredicate") !== -1 || userRole.split(",").indexOf("viewPerformanceScore") !== -1 || userRole.split(",").indexOf("viewPerformanceAppraisal") !== -1 || userRole.split(",").indexOf("viewPerformanceAppraisalDetail") !== -1 || userRole.split(",").indexOf("viewEmployeeAssessment") !== -1)
                ? ""
                : " d-none",
          childItems: [
            {
              id: 1,
              label: "Guideline",
              link: "/#",
              parentId: "HumanResources",
              isChildItem: true,
              stateVariables: isKeyPerformanceSub,
              click: function (e) {
                e.preventDefault();
                setIsKeyPerformanceSub(!isKeyPerformanceSub);
              },
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewPerformancePredicate") !== -1 || userRole.split(",").indexOf("viewPerformanceScore") !== -1 || userRole.split(",").indexOf("viewPerformanceAppraisal") !== -1 || userRole.split(",").indexOf("viewPerformanceAppraisalDetail") !== -1) ? "" : " d-none",
              childItems: [
                {
                  id: 1,
                  label: "Predikat",
                  link: "/performance-predicate",
                  parentId: "HumanResources",
                  visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPerformancePredicate") !== -1 ? "" : " d-none",
                },
                {
                  id: 2,
                  label: "Skor",
                  link: "/performance-score",
                  parentId: "HumanResources",
                  visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPerformanceScore") !== -1 ? "" : " d-none",
                },
                {
                  id: 3,
                  label: "Panduan Penilaian",
                  link: "/performance-appraisal",
                  parentId: "HumanResources",
                  visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewPerformanceAppraisal") !== -1 || userRole.split(",").indexOf("viewPerformanceAppraisalDetail") !== -1) ? "" : " d-none",
                },
              ],
            },
            {
              id: 2,
              label: "Penilaian",
              link: "/performance-assessment",
              parentId: "HumanResources",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewEmployeeAssessment") !== -1 ? "" : " d-none",
            },
          ],
        },
      ],
    },
    {
      id: "Products",
      label: "Produk & Jasa",
      icon: "ri-barcode-line",
      link: "/#",
      stateVariables: isProducts,
      click: function (e) {
        e.preventDefault();
        setIsProducts(!isProducts);
        setIsCurrentState("Products");
        updateIconSidebar(e);
      },
      visible:
        userType === "admin" || userType === "client" || userType === "company"
          ? ""
          : userRole && (userRole.split(",").indexOf("viewProductOption") !== -1 || userRole.split(",").indexOf("viewProductTag") !== -1 || userRole.split(",").indexOf("viewProduct") !== -1 || userRole.split(",").indexOf("viewMaterial") !== -1 || userRole.split(",").indexOf("viewProductGeneral") !== -1 || userRole.split(",").indexOf("viewProductBlock") !== -1 || userRole.split(",").indexOf("viewProductCategory") !== -1 || userRole.split(",").indexOf("viewProductDetail") !== -1)
            ? ""
            : " d-none",
      subItems: [
        {
          id: "menuProductCategories",
          label: "Product Option",
          link: "/#",
          parentId: "Products",
          isChildItem: true,
          stateVariables: isProductCategories,
          click: function (e) {
            e.preventDefault();
            setIsProductCategories(!isProductCategories);
          },
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewProductOption") !== -1 || userRole.split(",").indexOf("viewProductCategory") !== -1 || userRole.split(",").indexOf("viewProductTag") !== -1 || userRole.split(",").indexOf("viewBrand") !== -1) ? "" : " d-none",
          childItems: [
            {
              id: "menuBrand",
              label: "Brand",
              link: "/brand",
              parentId: "Products",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewBrand") !== -1 ? "" : " d-none",
            },
            {
              id: 2,
              label: "Tag",
              link: "/product-tag",
              parentId: "Products",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewProductTag") !== -1 ? "" : " d-none",
            },
            {
              id: 3,
              label: "Type",
              link: "/product-category",
              parentId: "Products",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewProductCategory") !== -1 ? "" : " d-none",
            },
            {
              id: 1,
              label: "Blok",
              link: "/product-block",
              parentId: "Products",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewProductBlock") !== -1 ? "" : " d-none",
            },
            //  {
            //   id: 1,
            //   label: "Varian",
            //   link: "/product-option",
            //   parentId: "Products",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewProductOption") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: 4,
            //   label: "Credit Option",
            //   link: "/credit-option",
            //   parentId: "Products",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCreditOption") !== -1 ? "" : " d-none",
            // },
          ],
        },
        {
          id: "menuProducts",
          label: "Unit Rumah",
          link: "/product",
          parentId: "Products",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewProduct") !== -1 ? "" : " d-none",
        },
        {
          id: "menuMaterial",
          label: "Produk Material",
          link: "/material",
          parentId: "Products",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewMaterial") !== -1 ? "" : " d-none",
        },
        {
          id: "menuProductGeneral",
          label: "Produk Umum",
          link: "/product-general",
          parentId: "Products",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewProductGeneral") !== -1 ? "" : " d-none",
        },
      ],
    },
    {
      id: "Assets",
      label: "Asset",
      icon: "ri-hotel-line",
      link: "/#",
      stateVariables: isAssets,
      visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewAssetCategory") !== -1 || userRole.split(",").indexOf("viewAssetClass") !== -1 || userRole.split(",").indexOf("viewAssetTag") !== -1 || userRole.split(",").indexOf("viewAsset") !== -1 || userRole.split(",").indexOf("viewAssetDisposal") !== -1 || userRole.split(",").indexOf("viewAssetDepreciation") !== -1) ? "" : " d-none",
      click: function (e) {
        e.preventDefault();
        setIsAssets(!isAssets);
        setIsCurrentState("Assets");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "menuAssetCategories",
          label: "Category",
          link: "/asset-category",
          parentId: "Assets",
          isChildItem: true,
          stateVariables: isAssetCategories,
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewAssetCategory") !== -1 || userRole.split(",").indexOf("viewAssetClass") !== -1 || userRole.split(",").indexOf("viewAssetTag") !== -1) ? "" : " d-none",
          click: function (e) {
            e.preventDefault();
            setIsAssetCategories(!isAssetCategories);
          },
          childItems: [
            {
              id: 1,
              label: "Category",
              link: "/asset-category",
              parentId: "Assets",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetCategory") !== -1 ? "" : " d-none",
            },
            {
              id: 2,
              label: "Class",
              link: "/asset-class",
              parentId: "Assets",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetClass") !== -1 ? "" : " d-none",
            },
            {
              id: 3,
              label: "Tag",
              link: "/asset-tag",
              parentId: "Assets",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetTag") !== -1 ? "" : " d-none",
            },
            {
              id: "FollowupList",
              label: "Daftar Follow Up",
              link: "/followup-lists",
              parentId: "Assets",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewFollowupList") !== -1 ? "" : " d-none",
            },
            {
              id: 4,
              label: "Kategori Inspeksi Aset",
              link: "/asset-inspection-category",
              parentId: "Tasks",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetInspectionCategory") !== -1 ? "" : " d-none",
            },
          ],
        },
        {
          id: "menuAssets",
          label: "Acquisition",
          link: "/asset",
          parentId: "Assets",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAsset") !== -1 ? "" : " d-none",
        },
        {
          id: "menuAssetInspection",
          label: "Inspeksi Aset",
          link: "/asset-inspection",
          parentId: "Assets",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetInspection") !== -1 ? "" : " d-none",
        },
        // {
        //   id: "menuAssetDepreciation",
        //   label: "Depreciation",
        //   link: "/asset-depreciation",
        //   parentId: "Assets",
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetDepreciation") !== -1 ? "" : " d-none",
        // },
        // {
        //   id: "menuAssetDisposal",
        //   label: "Disposal",
        //   link: "/asset-disposal",
        //   parentId: "Assets",
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetDisposal") !== -1 ? "" : " d-none",
        // }
      ],
    },
    {
      id: "Land",
      label: "Pertanahan",
      icon: "ri-road-map-line",
      link: "/#",
      stateVariables: isLand,
      visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewNominatif") !== -1 || userRole.split(",").indexOf("viewLegal") !== -1) ? "" : " d-none",
      click: function (e) {
        e.preventDefault();
        setIsLand(!isLand);
        setIsCurrentState("Land");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "menuLandReference",
          label: "Opsi Pertanahan",
          link: "/#",
          parentId: "Land",
          isChildItem: true,
          stateVariables: isLandOption,
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegalityDocument") !== -1 ? "" : "",
          click: function (e) {
            e.preventDefault();
            setIsLandOption(!isLandOption);
          },
          childItems: [
            {
              id: "LegalityDocument",
              label: "Daftar Perizinan",
              link: "/legality-document",
              parentId: "Land",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegalityDocument") !== -1 ? "" : " d-none",
            },
            {
              id: 1,
              label: "Jenis Legalitas",
              link: "/legality-type",
              parentId: "Assets",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegalityDocument") !== -1 ? "" : " d-none",
            },
          ],
        },
        {
          id: "menuLandAsset",
          label: "Tanah Aset",
          link: "/legality-asset",
          parentId: "Land",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
        },
        // {
        //   id: "menuNominatif",
        //   label: "Nominatif",
        //   link: "/nominatif",
        //   parentId: "Land",
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
        // },
        {
          id: "menuLegal",
          label: "Nominatif",
          link: "/legality",
          parentId: "Land",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
        },
        {
          id: "menuLegal",
          label: "Sertifikat Induk",
          link: "/legality-master",
          parentId: "Land",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
        },
        {
          id: "menuLegalFraction",
          label: "Sertifikat Pecahan",
          link: "/legality-fractional",
          parentId: "Land",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
        },
        {
          id: "menuLegalFraction",
          label: "Sertifikat Penggabungan",
          link: "/legality-merge",
          parentId: "Land",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
        },
        // {
        //   id: "menuSalesLegalitas",
        //   label: "Sertifikat Pecahan",
        //   link: "/sales-legality",
        //   parentId: "Sales",
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
        // },
        // {
        //   id: "menuLegal",
        //   label: "Perizinan",
        //   link: "/#",
        //   parentId: "HumanResources",
        //   isChildItem: true,
        //   stateVariables: isLegal,
        //   click: function (e) {
        //     e.preventDefault();
        //     setIsLegal(!isLegal);
        //   },
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewLegal") !== -1) ? "" : " d-none",
        //   childItems: [
        //     {
        //       id: 1,
        //       label: "Siteplan",
        //       link: "/legal-siteplan",
        //       parentId: "HumanResources",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
        //     },
        //     {
        //       id: 2,
        //       label: "Peil Banjir",
        //       link: "/legal-peil",
        //       parentId: "HumanResources",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
        //     },
        //     {
        //       id: 3,
        //       label: "Jembatan",
        //       link: "/legal-bridge",
        //       parentId: "HumanResources",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
        //     },
        //     {
        //       id: 4,
        //       label: "Rumija",
        //       link: "/legal-rumija",
        //       parentId: "HumanResources",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
        //     },
        //   ],
        // },
      ],
    },
    {
      id: "Permission",
      label: "Perizinan",
      icon: "ri-file-shield-2-line",
      link: "/legal-permission",
      stateVariables: isPermission,
      visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewPermission") !== -1) ? "" : " d-none",
      click: function (e) {
        e.preventDefault();
        setIsPermission(!isPermission);
        setIsCurrentState("Permission");
        updateIconSidebar(e);
      },
    },
    {
      id: "Legal",
      label: "Sub Notaris",
      icon: "ri-file-paper-line",
      link: "/#",
      stateVariables: isLegal,
      visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewLegal") !== -1) ? "" : " d-none",
      click: function (e) {
        e.preventDefault();
        setIsLegal(!isLegal);
        setIsCurrentState("Legal");
        updateIconSidebar(e);
      },
      subItems: [{
        id: 1,
        label: "Arsip Notaris",
        link: "/legality-notary",
        parentId: "menuNotaris",
        visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
      },
      {
        id: 3,
        label: "Pengambilan Konsumen",
        link: "/legality-stf",
        parentId: "menuNotaris",
        visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
      },
      {
        id: 4,
        label: "Salinan AJB",
        link: "/legality-ajb",
        parentId: "menuNotaris",
        visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
      },
      {
        id: 5,
        label: "Progres Notaris",
        link: "/legality-progress-notary",
        parentId: "menuNotaris",
        visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
      },
      {
        id: 6,
        label: "Termin Pembayaran",
        link: "/legality-term",
        parentId: "menuNotaris",
        visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
      },
      {
        id: 7,
        label: "Pengecekan Balik Nama",
        link: "/legality-check",
        parentId: "menuNotaris",
        visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
      },
      {
        id: 8,
        label: "Progres Balik Nama",
        link: "/legality-bn",
        parentId: "menuNotaris",
        visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLegal") !== -1 ? "" : " d-none",
      },
      ],
    },
    {
      id: "Engineering",
      label: "Teknik",
      icon: "ri-pencil-ruler-2-line",
      link: "/#",
      stateVariables: isEngineering,
      click: function (e) {
        e.preventDefault();
        setIsEngineering(!isEngineering);
        setIsCurrentState("Engineering");
        updateIconSidebar(e);
      },
      visible:
        userType === "admin" || userType === "client" || userType === "company"
          ? ""
          : userRole &&
            (userRole.split(",").indexOf("viewCivilAccountCategory") !== -1 ||
              userRole.split(",").indexOf("viewCivilContract") !== -1 ||
              userRole.split(",").indexOf("viewCivilAccount") !== -1 ||
              userRole.split(",").indexOf("viewCivilBudget") !== -1 ||
              userRole.split(",").indexOf("viewCivilProgression") !== -1 ||
              userRole.split(",").indexOf("viewCivilBudgetMonitoring") !== -1 ||
              userRole.split(",").indexOf("viewCivilBudgetDetail") !== -1 ||
              userRole.split(",").indexOf("viewCivilBudgetSchedule") !== -1)
            ? ""
            : " d-none",
      subItems: [
        {
          id: "budgetCategory",
          label: "Opsi Teknik",
          link: "/#",
          parentId: "Engineering",
          isChildItem: true,
          stateVariables: isBudgetCategory,
          click: function (e) {
            e.preventDefault();
            setIsBudgetCategory(!isBudgetCategory);
          },
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewCivilAccountCategory") !== -1 || userRole.split(",").indexOf("viewCivilAccount") !== -1) ? "" : " d-none",
          childItems: [
            {
              id: 1,
              label: "Kategori Anggaran",
              link: "/budgetAccountCategories",
              parentId: "Engineering",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCivilAccountCategory") !== -1 ? "" : " d-none",
            },
            {
              id: 2,
              label: "Item Anggaran",
              link: "/budgetAccountItems",
              parentId: "Engineering",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCivilAccount") !== -1 ? "" : " d-none",
            },
          ],
        },
        {
          id: "menuCivilBudget",
          label: "Anggaran",
          link: "/civilBudget",
          parentId: "Engineering",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCivilBudget") !== -1 ? "" : " d-none",
        },
        {
          id: "menuCivilBudgetSchedule",
          label: "Jadwal Anggaran",
          link: "/civilBudgetSchedule",
          parentId: "Engineering",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCivilBudgetSchedule") !== -1 ? "" : " d-none",
        },
        {
          id: "menuCivilContract",
          label: "Surat Tugas",
          link: "/civilContract",
          parentId: "Engineering",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCivilContract") !== -1 ? "" : " d-none",
        },
        {
          id: "menuCivilProgression",
          label: "Progres Pembangunan",
          link: "/civil-progression",
          parentId: "Engineering",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCivilProgression") !== -1 ? "" : " d-none",
        },
        {
          id: "menuCivilOpname",
          label: "Opname Pekerjaan",
          link: "/civil-opname",
          parentId: "Engineering",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCivilOpname") !== -1 ? "" : " d-none",
        },
        // {
        //   id: "menuCivilBudgetMonitoring",
        //   label: "Monitoring Anggaran",
        //   link: "/civilBudgetMonitoring",
        //   parentId: "Engineering",
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCivilBudgetMonitoring") !== -1 ? "" : " d-none",
        // },
        {
          id: "menuCivilBudgetControl",
          label: "Cost Control Global",
          link: "/civil-budget-control",
          parentId: "Engineering",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCivilBudgetMonitoring") !== -1 ? "" : " d-none",
        },
        {
          id: "menuCivilBudgetControl",
          label: "Cost Control Material",
          link: "/civil-budget-control-material",
          parentId: "Engineering",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCivilBudgetMonitoring") !== -1 ? "" : " d-none",
        },

        {
          id: "menuProductTransferBlock",
          label: "Pengeluaran Material",
          link: "/product-transfer-block",
          parentId: "Inventories",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCivilBudgetMonitoring") !== -1 ? "" : " d-none",
        },
      ],
    },
    {
      id: "Procurements",
      label: "Procurement",
      icon: "ri-bank-card-2-line",
      link: "/#",
      stateVariables: isProcurements,
      visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewVendor") !== -1 || userRole.split(",").indexOf("viewUom") !== -1 || userRole.split(",").indexOf("viewShipmentMethod") !== -1 || userRole.split(",").indexOf("viewShipmentCarrier") !== -1 || userRole.split(",").indexOf("viewPurchase") !== -1 || userRole.split(",").indexOf("viewPurchaseInvoice") !== -1) ? "" : " d-none",
      click: function (e) {
        e.preventDefault();
        setIsProcurements(!isProcurements);
        setIsCurrentState("Procurements");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "menuProcurementReference",
          label: "Purchase Option",
          link: "/#",
          parentId: "Procurements",
          isChildItem: true,
          stateVariables: isVendors,
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewVendor") !== -1 || userRole.split(",").indexOf("viewShipmentMethod") !== -1 || userRole.split(",").indexOf("viewShipmentCarrier") !== -1 || userRole.split(",").indexOf("viewUom") !== -1) ? "" : " d-none",
          click: function (e) {
            e.preventDefault();
            setIsVendors(!isVendors);
          },
          childItems: [
            {
              id: 3,
              label: "Shipping Method",
              link: "/shipping-method",
              parentId: "Procurements",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewShipmentMethod") !== -1 ? "" : " d-none",
            },
            {
              id: 4,
              label: "Shipping Carrier",
              link: "/shipping-carrier",
              parentId: "Procurements",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewShipmentCarrier") !== -1 ? "" : " d-none",
            },
            {
              id: 6,
              label: "Unit Measure",
              link: "/uom",
              parentId: "Procurements",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewUom") !== -1 ? "" : " d-none",
            },
          ],
        },
        {
          id: "menuPurchaseVendor",
          label: "Suplier",
          link: "/vendor",
          parentId: "Procurements",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewVendor") !== -1 ? "" : " d-none",
        },
        {
          id: "menuPurchase",
          label: "Material Purchasing",
          link: "/purchase",
          parentId: "Procurements",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchase") !== -1 ? "" : " d-none",
        },
        {
          id: "menuPurchaseGeneral",
          label: "Pembelian Umum",
          link: "/purchase-general",
          parentId: "Procurements",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchaseGeneral") !== -1 ? "" : " d-none",
        },
      ],
    },

    {
      id: "Inventories",
      label: "Inventory",
      icon: "bx bx-box",
      link: "/#",
      stateVariables: isInventories,
      visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewProductTransfer") !== -1 || userRole.split(",").indexOf("viewInboundPurchase") !== -1 || userRole.split(",").indexOf("viewProductInventory") !== -1 || userRole.split(",").indexOf("viewMaterialTransfer") !== -1) ? "" : " d-none",
      click: function (e) {
        e.preventDefault();
        setIsInventories(!isInventories);
        setIsCurrentState("Inventories");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "menuInboundPurchase",
          label: "Inbound Purchase",
          link: "/product-purchase-inbound",
          parentId: "Inventories",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewInboundPurchase") !== -1 ? "" : " d-none",
        },
        {
          id: "menuInboundTransfer",
          label: "Inbound Transfer",
          link: "/product-transfer-inbound",
          parentId: "Inventories",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewProductTransfer") !== -1 ? "" : " d-none",
        },
        {
          id: "menuInventories",
          label: "Inventory Stock",
          link: "/product-inventory",
          parentId: "Inventories",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewProductInventory") !== -1 || userRole.split(",").indexOf("viewProductInventoryDetail") !== -1) ? "" : " d-none",
        },
        {
          id: "menuStockCard",
          label: "Stock Card",
          link: "/product-stock-card",
          parentId: "Inventories",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewProductInventory") !== -1 || userRole.split(",").indexOf("viewProductInventoryDetail") !== -1) ? "" : " d-none",
        },
        {
          id: "menuStockadjustment",
          label: "Stock adjustment",
          link: "/product-stock-adjustment",
          parentId: "Inventories",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewProductInventory") !== -1 || userRole.split(",").indexOf("viewProductInventoryDetail") !== -1) ? "" : " d-none",
        },
        {
          id: "menuProductTransfers",
          label: "Distribusi Material",
          link: "/product-transfer",
          parentId: "Inventories",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewMaterialTransfer") !== -1 ? "" : " d-none",
        },
      ],
    },
    {
      id: "Sales",
      label: "Sales",
      icon: "ri-price-tag-3-line",
      link: "/#",
      stateVariables: isSales,
      visible:
        userType === "admin" || userType === "client" || userType === "company"
          ? ""
          : userRole &&
            (userRole.split(",").indexOf("viewCustomer") !== -1 ||
              userRole.split(",").indexOf("viewCustomerGroup") !== -1 ||
              userRole.split(",").indexOf("viewSales") !== -1 ||
              userRole.split(",").indexOf("SalesPayment") !== -1 ||
              userRole.split(",").indexOf("SalesReceivable") !== -1 ||
              userRole.split(",").indexOf("viewCustomerContact") !== -1 ||
              userRole.split(",").indexOf("viewDealTag") !== -1 ||
              userRole.split(",").indexOf("viewDeal") !== -1 ||
              userRole.split(",").indexOf("viewLead") !== -1 ||
              userRole.split(",").indexOf("viewSalesLegality") !== -1 ||
              userRole.split(",").indexOf("viewSalesComplain") !== -1 ||
              userRole.split(",").indexOf("ApplicantDocument") !== -1)
            ? ""
            : " d-none",
      click: function (e) {
        e.preventDefault();
        setIsSales(!isSales);
        setIsCurrentState("Sales");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "menuSalesReference",
          label: "Opsi Penjualan",
          link: "/#",
          parentId: "Sales",
          isChildItem: true,
          stateVariables: isSalesOption,
          visible: userType === "admin" || userType === "client" || userType === "company" ? "d-none" : userRole && (userRole.split(",").indexOf("viewApplicantDocument") !== -1 || userRole.split(",").indexOf("viewSalesChannel") !== -1 || userRole.split(",").indexOf("viewSalesType") !== -1 || userRole.split(",").indexOf("viewDealTag") !== -1 || userRole.split(",").indexOf("viewSalesReport") !== -1 || userRole.split(",").indexOf("viewSalesTarget") !== -1) ? "d-none" : " d-none",
          click: function (e) {
            e.preventDefault();
            setIsSalesOption(!isSalesOption);
          },
          childItems: [
            {
              id: "ApplicantDocument",
              label: "Berkas KPR",
              link: "/applicant-document",
              parentId: "Sales",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewApplicantDocument") !== -1 ? "" : " d-none",
            },
            // {
            //   id: 2,
            //   label: "Tag",
            //   link: "/deal-tags",
            //   parentId: "Sales",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewDealTag") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: "menuSalesTarget",
            //   label: "Target",
            //   link: "/sales-target",
            //   parentId: "Sales",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesTarget") !== -1 ? "" : " d-none",
            // },
            // {
            //   id: "menuSalesChannel",
            //   label: "Saluran Penjualan",
            //   link: "/sales-channel",
            //   parentId: "Sales",
            //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesChannel") !== -1 ? "" : " d-none",
            // },
            {
              id: "menuSalesType",
              label: "Jenis Penjualan",
              link: "/sales-type",
              parentId: "Sales",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesType") !== -1 ? "" : " d-none",
            },
          ],
        },
        // {
        //   id: "CRM",
        //   label: "CRM",
        //   link: "/#",
        //   parentId: "Sales",
        //   isChildItem: true,
        //   stateVariables: isLand,
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewDealTag") !== -1 || userRole.split(",").indexOf("viewDeal") !== -1 || userRole.split(",").indexOf("viewDealStatus") !== -1) ? "" : " d-none",
        //   click: function (e) {
        //     e.preventDefault();
        //     setIsLand(!isLand);
        //   },
        //   childItems: [
        //     {
        //       id: 1,
        //       label: "Status",
        //       link: "/deal-statues",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewDealStatus") !== -1 ? "" : " d-none",
        //     },
        //     {
        //       id: 3,
        //       label: "Deal",
        //       link: "/crm-deals",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewDeal") !== -1 ? "" : " d-none",
        //     },
        //     {
        //       id: 3,
        //       label: "Deal (Table)",
        //       link: "/deal-table",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewDeal") !== -1 ? "" : " d-none",
        //     },
        //   ],
        // },
        // {
        //   id: "Campaign",
        //   label: "Campaign",
        //   link: "/#",
        //   parentId: "Sales",
        //   isChildItem: true,
        //   stateVariables: isCampaigns,
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewCampaignPage") !== -1 || userRole.split(",").indexOf("viewCampaignDetail") !== -1 || userRole.split(",").indexOf("viewCampaign") !== -1) ? "" : " d-none",
        //   click: function (e) {
        //     e.preventDefault();
        //     setIsCampaigns(!isCampaigns);
        //   },
        //   childItems: [
        //     {
        //       id: 1,
        //       label: "Campagin Template",
        //       link: "/campaign-template",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCampaignPage") !== -1 ? "" : " d-none",
        //     },
        //     {
        //       id: 2,
        //       label: "Campaign",
        //       link: "/campaign",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCampaignDetail") !== -1 ? "" : " d-none",
        //     },
        //   ],
        // },
        // {
        //   id: "Survey",
        //   label: "Survey",
        //   link: "/#",
        //   parentId: "Sales",
        //   isChildItem: true,
        //   stateVariables: isSurvey,
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewSurveyScore") !== -1 || userRole.split(",").indexOf("viewSurveyTemplate") !== -1 || userRole.split(",").indexOf("viewSurvey") !== -1 || userRole.split(",").indexOf("viewSurveyTemplateDetail") !== -1) ? "" : " d-none",
        //   click: function (e) {
        //     e.preventDefault();
        //     setIsSurvey(!isSurvey);
        //   },
        //   childItems: [
        //     {
        //       id: 1,
        //       label: "Score",
        //       link: "/survey-scores",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSurveyScore") !== -1 ? "" : " d-none",
        //     },
        //     {
        //       id: 2,
        //       label: "Template",
        //       link: "/survey-templates",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSurveyTemplate") !== -1 ? "" : " d-none",
        //     },
        //     {
        //       id: 3,
        //       label: "Survey",
        //       link: "/surveys",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSurvey") !== -1 ? "" : " d-none",
        //     },
        //   ],
        // },
        // {
        //   id: "Customer",
        //   label: "Customer",
        //   link: "/#",
        //   parentId: "Sales",
        //   isChildItem: true,
        //   stateVariables: isCustomer,
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewCustomerGroup") !== -1 || userRole.split(",").indexOf("viewCustomer") !== -1 || userRole.split(",").indexOf("viewAgent") !== -1 || userRole.split(",").indexOf("viewAgency") !== -1) ? "" : " d-none",
        //   click: function (e) {
        //     e.preventDefault();
        //     setIsCustomer(!isCustomer);
        //   },
        //   childItems: [
        //     {
        //       id: 1,
        //       label: "Customer Group",
        //       link: "/customer-group",
        //       parentId: "Sales",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCustomerGroup") !== -1 ? "" : " d-none",
        //     },
        //     {
        //       id: 2,
        //       label: "Customer",
        //       link: "/customer",
        //       parentId: "Sales",
        //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCustomer") !== -1 ? "" : " d-none",
        //     },
        //   ],
        // },
        {
          id: "Marketing&Partner",
          label: "Sales dan Mitra",
          link: "/#",
          parentId: "Sales",
          isChildItem: true,
          stateVariables: isMarketing,
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewAgent") !== -1 || userRole.split(",").indexOf("viewAgency") !== -1) ? "" : " d-none",
          click: function (e) {
            e.preventDefault();
            setIsMarketing(!isMarketing);
          },
          childItems: [
            {
              id: 1,
              label: "Mitra",
              link: "/agencies",
              parentId: "Sales",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAgency") !== -1 ? "" : " d-none",
            },
            {
              id: 2,
              label: "Salesman",
              link: "/agents",
              parentId: "Sales",
              visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAgent") !== -1 ? "" : " d-none",
            },
          ],
        },
        // {
        //   id: "menuProductTransfers",
        //   label: "Product Distribution",
        //   link: "/product-transfer",
        //   parentId: "Sales",
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewProductTransfer") !== -1 ? "" : " d-none",
        // },
        // {
        //   id: "menuProductDeliveries",
        //   label: "Product Delivery",
        //   link: "/product-delivery",
        //   parentId: "Sales",
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewProductTransfer") !== -1 ? "" : " d-none",
        // },

        {
          id: "Customer",
          label: "Konsumen / Buku Tamu",
          link: "/customer",
          parentId: "Sales",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCustomer") !== -1 ? "" : " d-none",
        },
        {
          id: "menuSalesBooking",
          label: "Kasir",
          link: "/sales",
          parentId: "Sales",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSales") !== -1 ? "" : " d-none",
        },
        {
          id: "menuSalesStok",
          label: "Manajemen Stok",
          link: "/sales-management",
          parentId: "Sales",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSales") !== -1 ? "" : " d-none",
        },
        {
          id: "menuSalesDoc",
          label: "Rekap Dokumen",
          link: "/sales-document",
          parentId: "Sales",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSales") !== -1 ? "" : " d-none",
        },
        {
          id: "menuBankManajemen",
          label: "Rekap Bank",
          link: "/bank-management",
          parentId: "Sales",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSales") !== -1 ? "" : " d-none",
        },
        {
          id: "menuAnalisaSales",
          label: "Analisa Penjualan",
          link: "/sales-analytic",
          parentId: "Sales",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSales") !== -1 ? "" : " d-none",
        },

        // {
        //   id: "menuSalesApplicant",
        //   label: "Pemberkasan",
        //   link: "/sales-applicant",
        //   parentId: "Sales",
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSales") !== -1 ? "" : " d-none",
        // },
        // {
        //   id: "menuSalesReport",
        //   label: "Laporan Penjualan",
        //   link: "/sales-report",
        //   parentId: "Sales",
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewSalesReport") !== -1) ? "" : " d-none",
        // },
      ],
    },
    {
      id: "bast",
      label: "BAST",
      icon: "ri-hand-coin-line",
      link: "/#",
      stateVariables: isBAST,
      click: function (e) {
        e.preventDefault();
        setIsBAST(!isBAST);
        setIsCurrentState("BAST");
        updateIconSidebar(e);
      },
      visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewHandoverList") !== -1 || userRole.split(",").indexOf("viewSalesComplain") !== -1 || userRole.split(",").indexOf("viewProductHandover") !== -1) ? "" : " d-none",
      subItems: [
        {
          id: "menuLandReference",
          label: "Opsi BAST",
          link: "/#",
          parentId: "Land",
          isChildItem: true,
          stateVariables: isBASTOption,
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewHandoverList") !== -1 || userRole.split(",").indexOf("viewSalesComplain") !== -1 || userRole.split(",").indexOf("viewProductHandover") !== -1) ? "" : " d-none",
          click: function (e) {
            e.preventDefault();
            setIsBASTOption(!isBASTOption);
          },
          childItems: [
            {
              id: "HandoverList",
              label: "Daftar Serah Terima",
              link: "/handover-engineering-lists",
              parentId: "bast",
            },
            {
              id: "HandoverListComplain",
              label: "Daftar Progres Keluhan",
              link: "/handover-lists",
              parentId: "bast",
            },
          ],
        },

        {
          id: "menuProductHandover",
          label: "Serah Terima Unit",
          link: "/product-handover",
          parentId: "bast",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewHandoverList") !== -1 || userRole.split(",").indexOf("viewSalesComplain") !== -1 || userRole.split(",").indexOf("viewProductHandover") !== -1) ? "" : " d-none",
        },
        {
          id: "menuSalesComplain",
          label: "Keluhan Konsumen",
          link: "/sales-complain",
          parentId: "bast",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewHandoverList") !== -1 || userRole.split(",").indexOf("viewSalesComplain") !== -1 || userRole.split(",").indexOf("viewProductHandover") !== -1) ? "" : " d-none",
        },
      ],
    },
    {
      id: "Accounting",
      label: "Finance",
      icon: "ri-bank-line",
      link: "/#",
      stateVariables: isAccounting,
      visible:
        userType === "admin" || userType === "client" || userType === "company"
          ? ""
          : userRole && (userRole.split(",").indexOf("viewAccSetting") !== -1 || userRole.split(",").indexOf("viewAccLedger") !== -1 || userRole.split(",").indexOf("viewLoanTerm") !== -1 || userRole.split(",").indexOf("viewReimbursementType") !== -1 || userRole.split(",").indexOf("viewSalesPayment") !== -1 || userRole.split(",").indexOf("viewAccTransaction") !== -1)
            ? ""
            : " d-none",
      click: function (e) {
        e.preventDefault();
        setIsAccounting(!isAccounting);
        setIsCurrentState("Accounting");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "menuChartAccount",
          label: "Finance Option",
          link: "/#",
          parentId: "Accounting",
          isChildItem: true,
          stateVariables: isAccountingAccount,
          visible:
            userType === "admin" || userType === "client" || userType === "company"
              ? ""
              : userRole && (userRole.split(",").indexOf("viewAccCategory") !== -1 || userRole.split(",").indexOf("viewAccTag") !== -1 || userRole.split(",").indexOf("viewPaymentMethod") !== -1 || userRole.split(",").indexOf("viewPaymentTerm") !== -1 || userRole.split(",").indexOf("viewTransactionTax") !== -1 || userRole.split(",").indexOf("viewLoanTerm") !== -1 || userRole.split(",").indexOf("viewReimbursementType") !== -1 || userRole.split(",").indexOf("viewAccSetting") !== -1)
                ? ""
                : " d-none",
          click: function (e) {
            e.preventDefault();
            setIsAccountingAccount(!isAccountingAccount);
          },
          childItems: [
            {
              id: 1,
              label: "Tag",
              link: "/acc-tag",
              parentId: "Accounting",
              visible: "", //userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAccTag") !== -1 ? "" : " d-none",
            },
            {
              id: 2,
              label: "Account Category",
              link: "/acc-category",
              parentId: "Accounting",
              visible: "", //userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAccCategory") !== -1 ? "" : " d-none",
            },
            {
              id: 9,
              label: "Jenis Transaksi",
              link: "/payment-method",
              parentId: "Accounting",
              visible: "", //userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPaymentMethod") !== -1 ? "" : " d-none",
            },
            {
              id: 4,
              label: "Payment Term",
              link: "/payment-term",
              parentId: "Accounting",
              visible: "", //userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPaymentTerm") !== -1 ? "" : " d-none",
            },
            {
              id: 3,
              label: "Sales Discount",
              link: "/sales-promo",
              parentId: "Accounting",
              visible: "", //userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPaymentMethod") !== -1 ? "" : " d-none",
            },
            {
              id: 5,
              label: "Transaction Tax",
              link: "/transaction-tax",
              parentId: "Accounting",
              visible: "", //userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewTransactionTax") !== -1 ? "" : " d-none",
            },
            {
              id: 6,
              label: "Reimburse Type",
              link: "/reimbursement-type",
              parentId: "Accounting",
              visible: "", //userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewReimbursementType") !== -1 ? "" : " d-none",
            },
            {
              id: 7,
              label: "Loan Term",
              link: "/loan-term",
              parentId: "Accounting",
              visible: "", //userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLoanTerm") !== -1 ? "" : " d-none",
            },
            {
              id: 8,
              label: "Setting",
              link: "/acc-setting",
              parentId: "Accounting",
              visible: "", //userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAccSetting") !== -1 ? "" : " d-none",
            },
          ],
        },
        {
          id: "menuAccTransactionReport",
          label: "Laporan",
          link: "/#",
          parentId: "Accounting",
          isChildItem: true,
          stateVariables: isFinanceReport,
          click: function (e) {
            e.preventDefault();
            setIsFinanceReport(!isFinanceReport);
          },
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAccTransaction") !== -1 ? "" : " d-none",
          childItems: [
            {
              id: 1,
              label: "Neraca",
              link: "/balance-sheet",
              parentId: "Accounting",
              visible: "", //userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAccTag") !== -1 ? "" : " d-none",
            },

            {
              id: 2,
              label: "Laba Rugi",
              link: "/profit-loss",
              parentId: "Accounting",
              visible: "", //userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAccTag") !== -1 ? "" : " d-none",
            },
          ],
        },
        {
          id: "menuAccTransaction",
          label: "Transaksi",
          link: "/acc-trans",
          parentId: "Accounting",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAccTransaction") !== -1 ? "" : " d-none",
        },
        {
          id: 3,
          label: "Daftar Akun",
          link: "/acc-account",
          parentId: "Accounting",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAccAccount") !== -1 ? "" : " d-none",
        },
        {
          id: "menuAccLedger",
          label: "Buku Besar",
          link: "/acc-ledger",
          parentId: "Accounting",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAccLedger") !== -1 ? "" : " d-none",
        },
        {
          id: "menuAccBudget",
          label: "Pengajuan Dana",
          link: "/acc-budget",
          parentId: "Accounting",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewAccTransaction") !== -1) ? "" : " d-none",
        },
        {
          id: "menuExpense",
          label: "Penggunaan Dana",
          link: "/expense",
          parentId: "Accounting",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewAccTransaction") !== -1) ? "" : " d-none",
        },
        {
          id: "menuPayable",
          label: "Hutang",
          link: "/payable",
          parentId: "Accounting",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewAccTransaction") !== -1) ? "" : " d-none",
        },
        // {
        //   id: "menuPayableAll",
        //   label: "Hutang All Cabang",
        //   link: "/payable-all",
        //   parentId: "Accounting",
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewAccTransaction") !== -1) ? "" : " d-none",
        // },
        {
          id: "menuMPD",
          label: "Pencairan KPR (MPD)",
          link: "/acc-sales",
          parentId: "Accounting",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAccTransaction") !== -1 ? "" : " d-none",
        },
        {
          id: "menuReceivable",
          label: "Piutang",
          link: "/receivable",
          parentId: "Accounting",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAccTransaction") !== -1 ? "" : " d-none",
        },
        // {
        //   id: "menuSalesFee",
        //   label: "Fee Penjualan",
        //   link: "/sales-fee",
        //   parentId: "Sales",
        //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesPayment") !== -1 ? "" : " d-none",
        // },
      ],
    },
    // {
    //   id: "finance-report",
    //   label: "Laporan",
    //   icon: "ri-file-chart-line",
    //   link: "/#",
    //   stateVariables: isFinanceReport,
    //   visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewFinanceReport") !== -1 ? "" : " d-none",
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsFinanceReport(!isFinanceReport);
    //     setIsCurrentState("FinanceReport");
    //     updateIconSidebar(e);
    //   },
    //   subItems: [
    //     {
    //       id: "menuCategory",
    //       label: "Category",
    //       link: "/content-categories",
    //       parentId: "Content",
    //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewContentCategory") !== -1 ? "" : " d-none",
    //     },
    //   ],
    // },
    {
      id: "Budget",
      label: "Cashflow",
      icon: "ri-funds-line",
      link: "/budget",
      stateVariables: isBudget,
      visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewBudget") !== -1 ? "" : " d-none",
      click: function (e) {
        e.preventDefault();
        setIsBudget(!isBudget);
        setIsCurrentState("Budget");
        updateIconSidebar(e);
      },
    },

    // {
    //     id: "Messages",
    //     label: "Messages",
    //     icon: "ri-mail-send-fill",
    //     link: "/message",
    //     click: function (e) {
    //         e.preventDefault();
    //         setIsCurrentState('Messages');
    //     },
    //     stateVariables: isMessage,
    // },
    {
      id: "Admin",
      label: "Admin",
      icon: "ri-edit-box-line",
      link: "/admin",
      visible: userType === "admin" ? "" : " d-none",
      click: function (e) {
        e.preventDefault();
        setIsCurrentState("Admin");
      },
      stateVariables: isAdmin,
    },
    {
      id: "content",
      label: "Content",
      icon: "ri-task-line",
      link: "/#",
      stateVariables: isContent,
      click: function (e) {
        e.preventDefault();
        setIsContent(!isContent);
        setIsCurrentState("Content");
        updateIconSidebar(e);
      },
      visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewContent") !== -1 || userRole.split(",").indexOf("viewContentCategory") !== -1 || userRole.split(",").indexOf("viewContentDetail") !== -1) ? "" : " d-none",
      subItems: [
        {
          id: "menuCategory",
          label: "Category",
          link: "/content-categories",
          parentId: "Content",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewContentCategory") !== -1 ? "" : " d-none",
        },
        // {
        //   id: "menuContent",
        //   label: "Content",
        //   link: "/content",
        //   parentId: "Content",
        //   visible:
        //     userType === "admin" || userType === "client" || userType === "company"
        //       ? ""
        //       : userRole &&
        //         (userRole.split(",").indexOf("viewContent") !== -1 ||
        //           userRole.split(",").indexOf("viewContentDetail") !== -1)
        //         ? ""
        //         : " d-none",
        // },
        {
          id: "menuContentNews",
          label: "News Content",
          link: "/content-news",
          parentId: "Content",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewContent") !== -1 || userRole.split(",").indexOf("viewContentDetail") !== -1) ? "" : " d-none",
        },
        {
          id: "menuContentBanner",
          label: "Banner Content",
          link: "/content-banner",
          parentId: "Content",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewContent") !== -1 || userRole.split(",").indexOf("viewContentDetail") !== -1) ? "" : " d-none",
        },
        {
          id: "menuContentSingleBanner",
          label: "Single Banner Content",
          link: "/content-single-banner",
          parentId: "Content",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewContent") !== -1 || userRole.split(",").indexOf("viewContentDetail") !== -1) ? "" : " d-none",
        },
        {
          id: "menuContentHelp",
          label: "Help Content",
          link: "/content-help",
          parentId: "Content",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewContent") !== -1 || userRole.split(",").indexOf("viewContentDetail") !== -1) ? "" : " d-none",
        },
        {
          id: "menuContentAbout",
          label: "About Content",
          link: "/content-about",
          parentId: "Content",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewContent") !== -1 || userRole.split(",").indexOf("viewContentDetail") !== -1) ? "" : " d-none",
        },
        {
          id: "menuContentKPR",
          label: "KPR Content",
          link: "/content-kpr",
          parentId: "Content",
          visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewContent") !== -1 || userRole.split(",").indexOf("viewContentDetail") !== -1) ? "" : " d-none",
        },
      ],
    },
    {
      id: "Storages",
      label: "File Storage",
      icon: "bx bx-hdd",
      link: "/storage",
      visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewFile") !== -1 || userRole.split(",").indexOf("viewFolder") !== -1) ? "" : " d-none",
      click: function (e) {
        e.preventDefault();
        setIsCurrentState("Storage");
      },
      stateVariables: isStorages,
    },
    {
      id: "Profiles",
      label: "Profile",
      icon: "ri-account-circle-line",
      link: "/profile",
      click: function (e) {
        e.preventDefault();
        setIsCurrentState("Profiles");
      },
      stateVariables: isProfiles,
    },
    {
      id: "Users",
      label: "Users",
      icon: "ri-admin-line",
      link: "/users",
      visible: userType === "admin" || userType === "client" ? "" : " d-none",
      click: function (e) {
        e.preventDefault();
        setIsCurrentState("Users");
      },
      stateVariables: isUsers,
    },

    // {
    //   id: "Report",
    //   label: "Reporting",
    //   icon: "ri-file-chart-line",
    //   link: "/#",
    //   stateVariables: isReport,
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsReport(!isReport);
    //     setIsCurrentState("Report");
    //     updateIconSidebar(e);
    //   },
    //   visible:
    //     userType === "admin" || userType === "client" || userType === "company"
    //       ? ""
    //       : userRole &&
    //         (userRole.split(",").indexOf("viewAttendanceReport") !== -1 ||
    //           userRole.split(",").indexOf("viewLeaveReport") !== -1 ||
    //           userRole.split(",").indexOf("viewPermissionReport") !== -1 ||
    //           userRole.split(",").indexOf("viewPerformanceReport") !== -1 ||
    //           userRole.split(",").indexOf("viewPayrollReport") !== -1 ||
    //           userRole.split(",").indexOf("viewAllowanceReport") !== -1 ||
    //           userRole.split(",").indexOf("viewDeductionReport") !== -1 ||
    //           userRole.split(",").indexOf("viewTax21Report") !== -1 ||
    //           userRole.split(",").indexOf("viewPurchaseSummary") !== -1 ||
    //           userRole.split(",").indexOf("viewPurchaseReport") !== -1 ||
    //           userRole.split(",").indexOf("viewPurchaseReportByProduct") !== -1 ||
    //           userRole.split(",").indexOf("viewPurchaseReportByDepartment") !== -1 ||
    //           userRole.split(",").indexOf("viewPurchaseReportByVendor") !== -1 ||
    //           userRole.split(",").indexOf("viewPurchaseReportByCategory") !== -1 ||
    //           userRole.split(",").indexOf("viewPurchaseReportByBranch") !== -1 ||
    //           userRole.split(",").indexOf("viewPurchaseReportByCompany") !== -1 ||
    //           userRole.split(",").indexOf("viewPurchaseReportByPaymentType") !== -1 ||
    //           userRole.split(",").indexOf("viewPurchaseReturnReport") !== -1 ||
    //           userRole.split(",").indexOf("viewPurchaseTaxReport") !== -1 ||
    //           userRole.split(",").indexOf("viewStockReport") !== -1 ||
    //           userRole.split(",").indexOf("viewStockCard") !== -1 ||
    //           userRole.split(",").indexOf("viewStockReportByBranch") !== -1 ||
    //           userRole.split(",").indexOf("viewStockReportByCompany") !== -1 ||
    //           userRole.split(",").indexOf("viewStockFoundandLossReport") !== -1 ||
    //           userRole.split(",").indexOf("viewStockDistributionReport") !== -1 ||
    //           userRole.split(",").indexOf("viewProductionCostReport") !== -1 ||
    //           userRole.split(",").indexOf("viewPorductionPlanningRealization") !== -1 ||
    //           userRole.split(",").indexOf("viewSalesSummary") !== -1 ||
    //           userRole.split(",").indexOf("viewSalesReport") !== -1 ||
    //           userRole.split(",").indexOf("viewSalesDailyReport") !== -1 ||
    //           userRole.split(",").indexOf("viewSalesReportByCustomer") !== -1 ||
    //           userRole.split(",").indexOf("viewSalesReportByProduct") !== -1 ||
    //           userRole.split(",").indexOf("viewSalesReportByCategory") !== -1 ||
    //           userRole.split(",").indexOf("viewSalesReportByBranch") !== -1 ||
    //           userRole.split(",").indexOf("viewSalesReportByCompany") !== -1 ||
    //           userRole.split(",").indexOf("viewSalesReportByPaymentType") !== -1 ||
    //           userRole.split(",").indexOf("viewSalesReportByCashier") !== -1 ||
    //           userRole.split(",").indexOf("viewSalesReportBySalesman") !== -1 ||
    //           userRole.split(",").indexOf("viewSalesReturnReport") !== -1 ||
    //           userRole.split(",").indexOf("viewSalesRefundReport") !== -1 ||
    //           userRole.split(",").indexOf("viewSalesTaxReport") !== -1 ||
    //           userRole.split(",").indexOf("viewSalesClosingReport") !== -1 ||
    //           userRole.split(",").indexOf("viewCustomerReport") !== -1 ||
    //           userRole.split(",").indexOf("viewCustomerPoinReport") !== -1 ||
    //           userRole.split(",").indexOf("viewCouponReport") !== -1 ||
    //           userRole.split(",").indexOf("viewComplimentReport") !== -1 ||
    //           userRole.split(",").indexOf("viewPromotionReport") !== -1 ||
    //           userRole.split(",").indexOf("viewCRMReport") !== -1 ||
    //           userRole.split(",").indexOf("viewTargetRealizationReport") !== -1 ||
    //           userRole.split(",").indexOf("viewAssetStockReport") !== -1 ||
    //           userRole.split(",").indexOf("viewAssetStockCard") !== -1 ||
    //           userRole.split(",").indexOf("viewAssetStockReportByBranch") !== -1 ||
    //           userRole.split(",").indexOf("viewAssetStockReportByCompany") !== -1 ||
    //           userRole.split(",").indexOf("viewAssetStockFoundandLossReport") !== -1 ||
    //           userRole.split(",").indexOf("viewAssetStockDistributionReport") !== -1)
    //         ? ""
    //         : " d-none",
    //   subItems: [
    //     {
    //       id: "menuReportHummanResources",
    //       label: "Human Resources",
    //       link: "/#",
    //       parentId: "Report",
    //       isChildItem: true,
    //       stateVariables: isReportHumanResource,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsReportHumanResource(!isReportHumanResource);
    //       },
    //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewAttendanceReport") !== -1 || userRole.split(",").indexOf("viewLeaveReport") !== -1 || userRole.split(",").indexOf("viewPermissionReport") !== -1 || userRole.split(",").indexOf("viewPerformanceReport") !== -1 || userRole.split(",").indexOf("viewPayrollReport") !== -1 || userRole.split(",").indexOf("viewAllowanceReport") !== -1 || userRole.split(",").indexOf("viewDeductionReport") !== -1 || userRole.split(",").indexOf("viewTax21Report") !== -1) ? "" : " d-none",
    //       childItems: [
    //         {
    //           id: 1,
    //           label: "Attendance Report",
    //           link: "/report-attendance",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAttendanceReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 2,
    //           label: "Leave Report",
    //           link: "/report-leave",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewLeaveReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 3,
    //           label: "Permission Report",
    //           link: "/report-permission",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPermissionReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 4,
    //           label: "Permission Report",
    //           link: "/report-permission",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPermissionReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 5,
    //           label: "Performance Report",
    //           link: "/report-performance",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPerformanceReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 6,
    //           label: "Payroll Report",
    //           link: "/report-payroll",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPayrollReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 7,
    //           label: "Allowance Report",
    //           link: "/report-allowance",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAllowanceReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 8,
    //           label: "Deduction Report",
    //           link: "/report-deduction",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewDeductionReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 9,
    //           label: "Tax PPH 21 Report",
    //           link: "/report-pph21",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewTax21Report") !== -1 ? "" : " d-none",
    //         },
    //       ],
    //     },
    //     {
    //       id: "menuReportProcurement",
    //       label: "Procurement",
    //       link: "/#",
    //       parentId: "Report",
    //       isChildItem: true,
    //       stateVariables: isReportProcurement,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsReportProcurement(!isReportProcurement);
    //       },
    //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewPurchaseSummary") !== -1 || userRole.split(",").indexOf("viewPurchaseReport") !== -1 || userRole.split(",").indexOf("viewPurchaseReportByProduct") !== -1 || userRole.split(",").indexOf("viewPurchaseReportByDepartment") !== -1 || userRole.split(",").indexOf("viewPurchaseReportByVendor") !== -1 || userRole.split(",").indexOf("viewPurchaseReportByCategory") !== -1 || userRole.split(",").indexOf("viewPurchaseReportByBranch") !== -1 || userRole.split(",").indexOf("viewPurchaseReportByCompany") !== -1 || userRole.split(",").indexOf("viewPurchaseReportByPaymentType") !== -1 || userRole.split(",").indexOf("viewPurchaseReturnReport") !== -1 || userRole.split(",").indexOf("viewPurchaseTaxReport") !== -1) ? "" : " d-none",
    //       childItems: [
    //         {
    //           id: 1,
    //           label: "Purchase Summary",
    //           link: "/report-purchase-summary",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchaseSummary") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 2,
    //           label: "Purchases",
    //           link: "/report-purchase-report",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchaseReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 3,
    //           label: "Purchases By Product",
    //           link: "/report-purchase-product",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchaseReportByProduct") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 4,
    //           label: "Purchases By Department",
    //           link: "/report-purchase-department",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchaseReportByDepartment") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 5,
    //           label: "Purchases By Vendor",
    //           link: "/report-purchase-vendor",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchaseReportByVendor") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 6,
    //           label: "Purchases By Category",
    //           link: "/report-purchase-category",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchaseReportByCategory") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 7,
    //           label: "Purchases By Branch",
    //           link: "/report-purchase-branch",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchaseReportByBranch") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 8,
    //           label: "Purchases By Company",
    //           link: "/report-purchase-company",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchaseReportByCompany") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 9,
    //           label: "Purchases By Payment Type",
    //           link: "/report-purchase-payment-type",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchaseReportByPaymentType") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 10,
    //           label: "Purchase Return",
    //           link: "/report-purchase-return",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchaseReturnReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 11,
    //           label: "Purchase Tax",
    //           link: "/report-purchase-tax",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchaseTaxReport") !== -1 ? "" : " d-none",
    //         },
    //       ],
    //     },
    //     {
    //       id: "menuReportProductInventory",
    //       label: "Product Inventories",
    //       link: "/#",
    //       parentId: "Report",
    //       isChildItem: true,
    //       stateVariables: isReportProductInventory,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsReportProductInventory(!isReportProductInventory);
    //       },
    //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewStockReport") !== -1 || userRole.split(",").indexOf("viewStockCard") !== -1 || userRole.split(",").indexOf("viewStockReportByBranch") !== -1 || userRole.split(",").indexOf("viewStockReportByCompany") !== -1 || userRole.split(",").indexOf("viewStockFoundandLossReport") !== -1 || userRole.split(",").indexOf("viewStockDistributionReport") !== -1) ? "" : " d-none",
    //       childItems: [
    //         {
    //           id: 1,
    //           label: "Product Stock Report",
    //           link: "/report-product-stock",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewStockReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 2,
    //           label: "Product Stock Card",
    //           link: "/report-product-stock-card",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewStockCard") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 3,
    //           label: "Product Stock By Branch",
    //           link: "/report-product-stock-branch",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewStockReportByBranch") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 4,
    //           label: "Product Stock By Company",
    //           link: "/report-stock-company",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewStockReportByCompany") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 5,
    //           label: "Product Stock Found and Loss",
    //           link: "/report-product-stock-found-loss",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewStockFoundandLossReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 6,
    //           label: " Product Stock Distribution",
    //           link: "/report-product-stock-distribution",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewStockDistributionReport") !== -1 ? "" : " d-none",
    //         },
    //       ],
    //     },
    //     {
    //       id: "menuReportProduction",
    //       label: "Production",
    //       link: "/#",
    //       parentId: "Report",
    //       isChildItem: true,
    //       stateVariables: isReportProduction,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsReportProduction(!isReportProduction);
    //       },
    //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewProductionCostReport") !== -1 || userRole.split(",").indexOf("viewPorductionPlanningRealization") !== -1) ? "" : " d-none",
    //       childItems: [
    //         {
    //           id: 1,
    //           label: "Production Cost Report",
    //           link: "/report-civil_budget-cost",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewProductionCostReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 2,
    //           label: "Porduction Planning Realization",
    //           link: "/report-civil_budget-realization",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPorductionPlanningRealization") !== -1 ? "" : " d-none",
    //         },
    //       ],
    //     },
    //     {
    //       id: "menuReportSales",
    //       label: "Sales",
    //       link: "/#",
    //       parentId: "Report",
    //       isChildItem: true,
    //       stateVariables: isReportSales,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsReportSales(!isReportSales);
    //       },
    //       visible: userType === "admin" || userType === "client" || userType === "company" ? ""
    //         : userRole &&
    //           (userRole.split(",").indexOf("viewSalesSummary") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReport") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesDailyReport") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByCustomer") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByProduct") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByCategory") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByBranch") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByCompany") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByPaymentType") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByCashier") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportBySalesman") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReturnReport") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesRefundReport") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesTaxReport") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesClosingReport") !== -1 ||
    //             userRole.split(",").indexOf("viewCustomerReport") !== -1 ||
    //             userRole.split(",").indexOf("viewCustomerPoinReport") !== -1 ||
    //             userRole.split(",").indexOf("viewCouponReport") !== -1 ||
    //             userRole.split(",").indexOf("viewComplimentReport") !== -1 ||
    //             userRole.split(",").indexOf("viewPromotionReport") !== -1 ||
    //             userRole.split(",").indexOf("viewCRMReport") !== -1 ||
    //             userRole.split(",").indexOf("viewTargetRealizationReport") !== -1)
    //           ? ""
    //           : " d-none",
    //       childItems: [
    //         {
    //           id: 1,
    //           label: "Laporan Harian",
    //           link: "/report-sales-daily",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 2,
    //           label: "Laporan Berkas Bank",
    //           link: "/report-sales-bank",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 3,
    //           label: "Laporan Unit Terjual",
    //           link: "/report-sales-unit",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 3,
    //           label: "Sales Daily Report",
    //           link: "/report-sales-daily",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesDailyReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 4,
    //           label: "Sales By Product",
    //           link: "/report-sales-product",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReportByProduct") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 5,
    //           label: "Sales By Customer",
    //           link: "/report-sales-vendor",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReportByCustomer") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 6,
    //           label: "Sales By Category",
    //           link: "/report-sales-category",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReportByCategory") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 7,
    //           label: "Sales By Branch",
    //           link: "/report-sales-branch",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReportByBranch") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 8,
    //           label: "Sales By Company",
    //           link: "/report-sales-company",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReportByCompany") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 9,
    //           label: "Sales By Payment Type",
    //           link: "/report-sales-payment-type",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReportByPaymentType") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 10,
    //           label: "Sales Return",
    //           link: "/report-sales-return",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReturnReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 11,
    //           label: "Sales Refund",
    //           link: "/report-sales-refund",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesRefundReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 12,
    //           label: "Sales Tax",
    //           link: "/report-sales-tax",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesTaxReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 13,
    //           label: "Sales Closing Report",
    //           link: "/report-sales-closing",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesClosingReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 14,
    //           label: "Customer",
    //           link: "/report-sales-customer",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCustomerReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 15,
    //           label: "Customer Point",
    //           link: "/report-sales-customer-point",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCustomerPoinReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 16,
    //           label: "Coupon",
    //           link: "/report-sales-coupon",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCouponReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 17,
    //           label: "Compliment",
    //           link: "/report-sales-compliment",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewComplimentReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 18,
    //           label: "Promotion",
    //           link: "/report-sales-promotion",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPromotionReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 19,
    //           label: "CRM",
    //           link: "/report-sales-crm",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewCRMReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 20,
    //           label: "Target & Realization",
    //           link: "/report-sales-target",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewTargetRealizationReport") !== -1 ? "" : " d-none",
    //         },
    //       ],
    //     },
    //     {
    //       id: "menuReportPurchase",
    //       label: "Purchase",
    //       link: "/#",
    //       parentId: "Report",
    //       isChildItem: true,
    //       stateVariables: isReportPurchase,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsReportPurchase(!isReportPurchase);
    //       },
    //       visible: userType === "admin" || userType === "client" || userType === "company" ? ""
    //         : userRole &&
    //           (userRole.split(",").indexOf("viewSalesSummary") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReport") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesDailyReport") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByCustomer") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByProduct") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByCategory") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByBranch") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByCompany") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByPaymentType") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByCashier") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportBySalesman") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReturnReport") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesRefundReport") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesTaxReport") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesClosingReport") !== -1 ||
    //             userRole.split(",").indexOf("viewCustomerReport") !== -1 ||
    //             userRole.split(",").indexOf("viewCustomerPoinReport") !== -1 ||
    //             userRole.split(",").indexOf("viewCouponReport") !== -1 ||
    //             userRole.split(",").indexOf("viewComplimentReport") !== -1 ||
    //             userRole.split(",").indexOf("viewPromotionReport") !== -1 ||
    //             userRole.split(",").indexOf("viewCRMReport") !== -1 ||
    //             userRole.split(",").indexOf("viewTargetRealizationReport") !== -1)
    //           ? ""
    //           : " d-none",
    //       childItems: [
    //         {
    //           id: 1,
    //           label: "Laporan Pembelian Material",
    //           link: "/report-purchase-material",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchseReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 2,
    //           label: "Laporan Pembelian",
    //           link: "/report-purchase-general",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPurchseReport") !== -1 ? "" : " d-none",
    //         },
    //       ],
    //     },

    //     {
    //       id: "menuReportFinance",
    //       label: "Keuangan",
    //       link: "/#",
    //       parentId: "Report",
    //       isChildItem: true,
    //       stateVariables: isReportTransaction,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsReportTransaction(!isReportTransaction);
    //       },
    //       visible: userType === "admin" || userType === "client" || userType === "company" ? ""
    //         : userRole &&
    //           (userRole.split(",").indexOf("viewSalesSummary") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReport") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesDailyReport") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByCustomer") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByProduct") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByCategory") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByBranch") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByCompany") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByPaymentType") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportByCashier") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReportBySalesman") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesReturnReport") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesRefundReport") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesTaxReport") !== -1 ||
    //             userRole.split(",").indexOf("viewSalesClosingReport") !== -1 ||
    //             userRole.split(",").indexOf("viewCustomerReport") !== -1 ||
    //             userRole.split(",").indexOf("viewCustomerPoinReport") !== -1 ||
    //             userRole.split(",").indexOf("viewCouponReport") !== -1 ||
    //             userRole.split(",").indexOf("viewComplimentReport") !== -1 ||
    //             userRole.split(",").indexOf("viewPromotionReport") !== -1 ||
    //             userRole.split(",").indexOf("viewCRMReport") !== -1 ||
    //             userRole.split(",").indexOf("viewTargetRealizationReport") !== -1)
    //           ? ""
    //           : " d-none",
    //       childItems: [
    //         {
    //           id: 1,
    //           label: "Transaksi",
    //           link: "/report-transaction",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 1,
    //           label: "Saldo Akun Keuangan",
    //           link: "/report-account-balance",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewSalesReport") !== -1 ? "" : " d-none",
    //         },
    //       ],
    //     },
    //     {
    //       id: "menuReportAsset",
    //       label: "Asset",
    //       link: "/#",
    //       parentId: "Report",
    //       isChildItem: true,
    //       stateVariables: isReportAssetInventory,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsReportAssetInventory(!isReportAssetInventory);
    //       },
    //       visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewAssetStockReport") !== -1 || userRole.split(",").indexOf("viewAssetStockCard") !== -1 || userRole.split(",").indexOf("viewAssetStockReportByBranch") !== -1 || userRole.split(",").indexOf("viewAssetStockReportByCompany") !== -1 || userRole.split(",").indexOf("viewAssetStockFoundandLossReport") !== -1 || userRole.split(",").indexOf("viewAssetStockDistributionReport") !== -1) ? "" : " d-none",
    //       childItems: [
    //         {
    //           id: 1,
    //           label: "Asset Stock Report",
    //           link: "/report-asset-stock",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetStockReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 2,
    //           label: "Asset Stock Card",
    //           link: "/report-asset-stock-card",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetStockCard") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 3,
    //           label: "Asset Stock By Branch",
    //           link: "/report-asset-stock-branch",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetStockReportByBranch") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 4,
    //           label: "Asset Stock By Company",
    //           link: "/report-asset-company",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetStockReportByCompany") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 5,
    //           label: "Asset Stock Found and Loss",
    //           link: "/report-asset-stock-found-loss",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewAssetStockFoundandLossReport") !== -1 ? "" : " d-none",
    //         },
    //         {
    //           id: 6,
    //           label: " Asset Stock Distribution",
    //           link: "/report-asset-stock-distribution",
    //           parentId: "Report",
    //           visible: userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewPayrollReport") !== -1 ? "" : " d-none",
    //         },
    //       ],
    //     },
    //   ],
    //}
    {
      id: "Notif",
      label: "Notifikasi",
      icon: "ri-notification-line",
      link: "/notif",
      stateVariables: isNotif,
      visible: "",
      click: function (e) {
        e.preventDefault();
        setIsNotif(!isNotif);
        setIsCurrentState("Budget");
        updateIconSidebar(e);
      },
    },
    {
      id: "CustomerAgent",
      label: "Konsumen",
      icon: "ri-group-line",
      link: "/customer",
      stateVariables: isCustomer,
      visible: userType === "agent" ? "" : " d-none",
      click: function (e) {
        e.preventDefault();
        setIsCustomer(!isCustomer);
        setIsCurrentState("Customer");
        updateIconSidebar(e);
      },
    },
  ];

  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
